import { render, staticRenderFns } from "./HeroDefaultPost.vue?vue&type=template&id=137c4092"
import script from "./HeroDefaultPost.vue?vue&type=script&lang=js"
export * from "./HeroDefaultPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports